function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as React from "react";
import DatePicker from "react-datepicker";
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import "./poliza.scss";
import { sortByOptions, listRamosGenerales, listTipoDePago } from "../../utils/data";
import { InputRut } from "../../helperComponents/";
export var defaultSearchTerms = {
  proposal_code: "",
  code: "",
  poliza_asegurado_rut_or_name: null,
  finish_date_from: null,
  finish_date_until: null,
  sort_by: "",
  company_id: null,
  ramo: "",
  tipo_de_pago: ""
};

var SearchPoliza = function SearchPoliza(props) {
  var searchTerms = props.searchTerms,
      onChangeSearchTerms = props.onChangeSearchTerms,
      onSubmit = props.onSubmit,
      _props$companies = props.companies,
      companies = _props$companies === void 0 ? [] : _props$companies,
      token = props.token;
  var companyOptions = companies && companies.map(function (company) {
    return {
      label: company.name,
      value: "".concat(company.id)
    };
  });
  var ramosOptions = listRamosGenerales.map(function (ramo) {
    return {
      label: ramo,
      value: ramo
    };
  });
  var tipoDePagoOptions = listTipoDePago && listTipoDePago.map(function (tipoDePago) {
    return {
      label: tipoDePago,
      value: tipoDePago
    };
  });
  var selectedSortBy = searchTerms.sort_by ? sortByOptions.find(function (option) {
    return option.value === searchTerms.sort_by;
  }) : null;
  var selectedCompany = searchTerms.company_id ? companyOptions.find(function (option) {
    return option.value === searchTerms.company_id;
  }) : null;
  return /*#__PURE__*/React.createElement("form", {
    className: "form-horizontal cntSearchPoliza",
    onSubmit: onSubmit && onSubmit,
    autoComplete: "off"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card"
  }, /*#__PURE__*/React.createElement("div", {
    className: "card-header cardHeader"
  }, /*#__PURE__*/React.createElement("h5", null, "Bit\xE1cora de propuestas y P\xF3lizas")), /*#__PURE__*/React.createElement("div", {
    className: "card-body cardBody"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group row"
  }, /*#__PURE__*/React.createElement("label", {
    className: "col-sm-4 col-form-label"
  }, "N\xBA Propuesta"), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: "form-control-plaintext",
    placeholder: "N\xBA de Propuesta",
    value: searchTerms.proposal_code,
    onChange: function onChange(event) {
      return onChangeSearchTerms(_objectSpread(_objectSpread({}, searchTerms), {}, {
        proposal_code: event.target.value
      }), false);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "form-group row"
  }, /*#__PURE__*/React.createElement("label", {
    className: "col-sm-4 col-form-label"
  }, "Fecha fin vigencia desde"), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/React.createElement(DatePicker, {
    className: "form-control",
    dateFormat: "dd-MM-yyyy",
    selected: searchTerms.finish_date_from,
    maxDate: searchTerms.finish_date_until || null,
    onChange: function onChange(item) {
      onChangeSearchTerms(_objectSpread(_objectSpread({}, searchTerms), {}, {
        finish_date_from: item
      }), false);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "form-group row"
  }, /*#__PURE__*/React.createElement("label", {
    className: "col-sm-4 col-form-label"
  }, "Ramo"), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/React.createElement(Select, {
    options: ramosOptions,
    value: ramosOptions.find(function (ramo) {
      return ramo.value === searchTerms.ramo;
    }),
    isSearchable: true,
    isClearable: true,
    placeholder: "Seleccione...",
    onChange: function onChange(item) {
      return onChangeSearchTerms && onChangeSearchTerms(_objectSpread(_objectSpread({}, searchTerms), {}, {
        ramo: item === null || item === void 0 ? void 0 : item.value
      }), false);
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group row"
  }, /*#__PURE__*/React.createElement("label", {
    className: "col-sm-4 col-form-label"
  }, "N\xBA P\xF3liza"), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: "form-control-plaintext",
    placeholder: "N\xBA de P\xF3liza",
    value: searchTerms.code,
    onChange: function onChange(event) {
      return onChangeSearchTerms(_objectSpread(_objectSpread({}, searchTerms), {}, {
        code: event.target.value
      }), false);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "form-group row"
  }, /*#__PURE__*/React.createElement("label", {
    className: "col-sm-4 col-form-label"
  }, "Fecha fin vigencia hasta"), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/React.createElement(DatePicker, {
    className: "form-control",
    dateFormat: "dd-MM-yyyy",
    selected: searchTerms.finish_date_until,
    minDate: searchTerms.finish_date_from || null,
    onChange: function onChange(item) {
      onChangeSearchTerms(_objectSpread(_objectSpread({}, searchTerms), {}, {
        finish_date_until: item
      }), false);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "form-group row"
  }, /*#__PURE__*/React.createElement("label", {
    className: "col-sm-4 col-form-label"
  }, "Forma de Pago"), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/React.createElement(Select, {
    options: tipoDePagoOptions,
    value: tipoDePagoOptions.find(function (tipoDePago) {
      return tipoDePago.value === searchTerms.tipo_de_pago;
    }),
    isSearchable: true,
    isClearable: true,
    placeholder: "Seleccione...",
    onChange: function onChange(item) {
      return onChangeSearchTerms && onChangeSearchTerms(_objectSpread(_objectSpread({}, searchTerms), {}, {
        tipo_de_pago: item === null || item === void 0 ? void 0 : item.value
      }), false);
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group row"
  }, /*#__PURE__*/React.createElement("label", {
    className: "col-sm-4 col-form-label"
  }, "Rut o nombre Asegurado"), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/React.createElement(InputRut, {
    className: "form-control",
    value: searchTerms.poliza_asegurado_rut_or_name,
    onUserIsExist: function onUserIsExist(user) {
      return onChangeSearchTerms && onChangeSearchTerms(_objectSpread(_objectSpread({}, searchTerms), {}, {
        poliza_asegurado_rut_or_name: user.rut
      }), false);
    },
    onInputChange: function onInputChange(value) {
      return onChangeSearchTerms && onChangeSearchTerms(_objectSpread(_objectSpread({}, searchTerms), {}, {
        poliza_asegurado_rut_or_name: value
      }), false);
    },
    onlyInput: true,
    token: token
  }))), /*#__PURE__*/React.createElement("div", {
    className: "form-group row"
  }, /*#__PURE__*/React.createElement("label", {
    className: "col-sm-4 col-form-label"
  }, "Compa\xF1\xEDa"), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/React.createElement(Select, {
    options: companyOptions,
    defaultValue: selectedCompany,
    isSearchable: true,
    isClearable: true,
    placeholder: "Selecciona Compañia...",
    onChange: function onChange(item, action) {
      onChangeSearchTerms && onChangeSearchTerms(_objectSpread(_objectSpread({}, searchTerms), {}, {
        company_id: item === null || item === void 0 ? void 0 : item.value
      }), false);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "form-group row"
  }, /*#__PURE__*/React.createElement("label", {
    className: "col-sm-4 col-form-label"
  }, "Ordenar por"), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-8"
  }, /*#__PURE__*/React.createElement(Select, {
    options: sortByOptions,
    value: selectedSortBy,
    isSearchable: true,
    isClearable: true,
    placeholder: "Seleccione...",
    onChange: function onChange(item) {
      return onChangeSearchTerms && onChangeSearchTerms(_objectSpread(_objectSpread({}, searchTerms), {}, {
        sort_by: item === null || item === void 0 ? void 0 : item.value
      }), false);
    }
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "card-footer cardFooter"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-primary btn-block",
    type: "submit"
  }, "Buscar")), /*#__PURE__*/React.createElement("div", {
    className: "col-md-1"
  }, /*#__PURE__*/React.createElement("button", {
    className: "btn btn-default btn-block",
    type: "button",
    onClick: function onClick() {
      onChangeSearchTerms(_objectSpread({}, defaultSearchTerms), true);
    }
  }, "Limpiar")))));
};

export default SearchPoliza;